import { render, staticRenderFns } from "./ChangeDistributionCenterDialog.vue?vue&type=template&id=3a3fd9ac&scoped=true"
import script from "./ChangeDistributionCenterDialog.vue?vue&type=script&lang=js"
export * from "./ChangeDistributionCenterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fd9ac",
  null
  
)

export default component.exports